import(/* webpackMode: "eager", webpackExports: ["NavMobile","Nav","Footer"] */ "/Users/ashwinkallaje/Projects/throughgen/panda-framework/packages/panda0-ui/dist/index.mjs");
